import {
  TOGGLE_LOADING_OFFER_WIDGET,
  UPDATE_OFFER_WIDGET,
  IOfferWidgetStoreState,
  OffeWidgetActionTypes,
  RESET_OFFER_WIDGET,
} from './types';

const initialState: IOfferWidgetStoreState = {
  data: null,
  isLoading: false,
};

export default function srpPageReducer(state = initialState, action: OffeWidgetActionTypes) {
  switch (action.type) {
    case TOGGLE_LOADING_OFFER_WIDGET:
      return {
        ...state,
        isLoading: action.actionData,
      };

    case UPDATE_OFFER_WIDGET:
      return {
        ...state,
        data: action.actionData,
      };

    case RESET_OFFER_WIDGET:
      return {
        ...state,
        data: null,
      };

    default:
      return state;
  }
}
